<script setup>
import {
    Carousel as Slider,
    Slide,
} from 'vue3-carousel';

import {
    ref,
} from 'vue';

import AppLink from '../../atoms/app/AppLink';
import SliderArrowControl from '../../molecules/slider/SliderArrowControl';
import TextHeadline from '../../atoms/text/TextHeadline';

defineProps({
    logCreateCv: {
        type: Function,
        default: () => {},
    },
});

const carousel = ref(null);
</script>

<template>
    <Slider
        ref="carousel"
        :wrap-around="true"
        :mouse-drag="false"
        class="c-sliderCvBenefits"
        data-qa="slider benefits"
    >
        <Slide
            class="k-c-cupcake"
            data-qa="slide"
        >
            <div class="k-c-cupcake__text">
                <AppLink
                    :to="{ name: 'page-profile-create-onepage' }"
                    @click="logCreateCv"
                >
                    <TextHeadline
                        :level="4"
                        data-qa="headline"
                    >
                        Job-Anfragen erhalten
                    </TextHeadline>
                </AppLink>
                Lass dich bequem von Arbeitgebern finden – auch wenn du nicht aktiv suchst.
            </div>
        </Slide>
        <Slide
            class="k-c-cupcake"
            data-qa="slide"
        >
            <div class="k-c-cupcake__text">
                <AppLink
                    :to="{ name: 'page-profile-create-onepage' }"
                    @click="logCreateCv"
                >
                    <TextHeadline
                        :level="4"
                        data-qa="headline apply"
                    >
                        Individuelles Design
                    </TextHeadline>
                </AppLink>
                3 Vorlagen, Farbvarianten und Schriftarten – so wird dein Lebenslauf einzigartig wie du.
            </div>
        </Slide>
        <Slide
            class="k-c-cupcake"
            data-qa="slide"
        >
            <div class="k-c-cupcake__text">
                <AppLink
                    :to="{ name: 'page-profile-create-onepage' }"
                    @click="logCreateCv"
                >
                    <TextHeadline
                        :level="4"
                        data-qa="headline pdf"
                    >
                        Einfach überzeugen
                    </TextHeadline>
                </AppLink>
                Punkte mit deinem professionellen Lebenslauf – einfach als PDF speichern oder direkt bewerben.
            </div>
        </Slide>
        <template #addons>
            <SliderArrowControl
                :next="() => carousel?.next()"
                :prev="() => carousel?.prev()"
                data-qa="slider controls"
            />
        </template>
    </Slider>
</template>

<style lang="scss">
@import '../../../assets/scss/settings/spacing';
@import '../../../../resources/assets/scss/dependencies/vue3-carousel';

.c-sliderCvBenefits {
    width: 100%;
}
</style>
